import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { DefaultSpinner } from '../../../global/spinner/default-spinner';
import { MeetingFormFields } from '../shared/meeting-form-fields/meeting-form-fields';
import DefaultButton from '../../../global/default-button/default-button';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { connectZoomVM } from '../../zoom.context';
import { ResourcesNavigation } from '../../../_events/_manage-event/shared/navigation/navigation';
import { ScheduleNewMeetingViewModel } from './schedule-meeting.viewmodel';

const ScheduleMeetingPresentation = injectIntl(mobxReact.observer((props: {vm: ScheduleNewMeetingViewModel; intl: IntlShape}) => {
    const { vm } = props;
    const { clonedMeetingId } = vm;
    const formFields = vm.getFormFields();

    return (
        <div>
            <section className='resources-tabs horizontal-row scheduled-meetings-list__horizontal-row'>
                <ResourcesNavigation />
            </section>
            <div className='schedule-meeting page-size-form-container'>
                <form className='oe-form'>
                    <div className='oe-form__header'>
                        <h2 className='oe-form__title'>
                            <FormattedMessage
                                id='oe.zoom.scheduleNewMeeting'
                                defaultMessage='Schedule New Zoom Meeting'
                                description='Label text'
                            />
                        </h2>
                    </div>

                <MeetingFormFields vm={formFields} clonedMeetingId={clonedMeetingId}/>

                    <div className='oe-form__footer'>
                        <DefaultButton
                            modifier='fat'
                            text={
                                <FormattedMessage
                                    id='oe.zoom.scheduleNewMeeting'
                                    defaultMessage='Schedule New Zoom Meeting'
                                    description='Label text'
                                />
                            }
                            onClick={vm.submitForm}
                        />
                    </div>
                </form>
                <DefaultSpinner visible={vm.getIsLoading()}/>
            </div>
        </div>
    );
}));

interface IContainerProps {
    clonedMeetingId: number;
}

const ScheduleMeetingContainer = withViewModel(
    ScheduleMeetingPresentation,
    (props: { clonedMeetingId: number }) => {
        const scheduleMeetingVM = new ScheduleNewMeetingViewModel(props.clonedMeetingId);
        if (props.clonedMeetingId) {
            scheduleMeetingVM.fetchMeetingDetails();
        }
        return scheduleMeetingVM;
    },
    props => [props.clonedMeetingId]
);

const ScheduleMeeting = connectZoomVM<IContainerProps>(ScheduleMeetingContainer, zoomVM => {
    return {
        clonedMeetingId: zoomVM.getMeetingId()
    };
});


export { ScheduleMeetingPresentation , ScheduleMeeting };
